module.exports = __webpack_public_path__ + "static/media/dominican-republic.d62c3674.svg";